// extracted by mini-css-extract-plugin
export default {"right":"toolbox_right__KnQiT"};